'use strict';

export const appDomain = 'https://stg-api.troll-tech.com';
export const frontDomain = 'https://stg-lotto.troll-tech.com';
export const googleTagManager = '';
export const devMode = false;
export const devMessage = '';
export const version = 'live-version';
// export const brand = 'winaija';
export const brand = 'qiwi';
export const serverBannerMessage = false;
export const afterComma = '0.2-2';
export const paystackKey = ''; /* it's used only in Winaija, but variable should exist here also! */
export const paystackChannels = ['bank', 'card', 'ussd', 'qr'];

// used on wd form
export const reCaptchaSiteKey = ''
export const reCaptchaSecretKey = ''